module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.fullsize ? 'isfullsize' : 'normal' + ' slideshow-wrapper'
  }, [(_vm.showNow || !_vm.fullsize) ? _c('agile', {
    ref: "main",
    staticClass: "main-slideshow",
    attrs: {
      "options": _vm.options1
    },
    on: {
      "beforeChange": function($event) {
        return _vm.syncThumbnails($event)
      }
    }
  }, [_vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "slide",
      on: {
        "click": function($event) {
          return _vm.openFullSlideShow(index)
        }
      }
    }, [_c('div', {
      staticClass: "blur"
    }), _vm._v(" "), _c('div', {
      staticClass: "image",
      style: ('background-image:url(' + image.path_corrected + ')')
    })])
  }), _vm._v(" "), _c('template', {
    slot: "prevButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg"
    }
  })]), _vm._v(" "), _c('template', {
    slot: "nextButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-right.svg"
    }
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.showNow || !_vm.fullsize) ? _c('agile', {
    ref: "thumbnails",
    staticClass: "thumbnails",
    attrs: {
      "options": _vm.options2
    }
  }, [_vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "slide thumbnail",
      on: {
        "click": function($event) {
          return _vm.$refs.main.goTo(index)
        }
      }
    }, [_c('div', {
      staticClass: "image",
      style: ('background-image:url(' + image.path_corrected + ')')
    })])
  }), _vm._v(" "), _c('template', {
    slot: "prevButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg"
    }
  })]), _vm._v(" "), _c('template', {
    slot: "nextButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-right.svg"
    }
  })])], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eefcb94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Slideshow.vue
// module id = 930
// module chunks = 0